import _implicitStylesheets from "./pricingV2.css";
import _implicitScopedStylesheets from "./pricingV2.scoped.css?scoped=true";
import _wdsLinkRenderer from "wds/linkRenderer";
import _listingPricingCard from "listing/pricingCard";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3 type-style="display-6" class="pricing-tab__heading${0}" data-testid="pricing-tab-heading" data-scroll-to="pricing-details"${"a0:data-dummy"}${2}>${"t1"}</h3>`;
const $fragment2 = parseFragment`<p type-style="body-2" class="pricing-tab__subsection-description${0}" data-testid="pricing-tab-subsection-description"${2}>${"t1"}</p>`;
const $fragment3 = parseFragment`<p type-style="body-2" class="pricing-tab__section-text${0}" data-testid="pricing-tab-requirements-text"${2}>${"t1"}</p>`;
const stc0 = {
  classMap: {
    "pricing-tab": true
  },
  key: 0
};
const stc1 = {
  "data-testid": "pricing-tab-additional-details"
};
const stc2 = {
  classMap: {
    "pricing-tab__grid": true
  },
  key: 8
};
const stc3 = {
  "data-testid": "pricing-card"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, k: api_key, i: api_iterator, h: api_element} = $api;
  return [api_element("div", stc0, [$cmp.hasDisplayableContent ? api_static_fragment($fragment1, 2, [api_static_part(0, {
    attrs: {
      "data-dummy": $cmp.scrollToParam
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.heading))]) : null, $cmp.hasDisplayableContent ? $cmp.hasPricingDescription ? api_static_fragment($fragment2, 4, [api_static_part(1, null, api_dynamic_text($cmp.pricingDescription))]) : null : null, $cmp.hasRequirementsAndLimitationsText ? api_static_fragment($fragment3, 6, [api_static_part(1, null, api_dynamic_text($cmp.requirementsAndLimitationsText))]) : null, $cmp.hasAdditionalDetails ? api_custom_element("wds-link-renderer", _wdsLinkRenderer, {
    attrs: stc1,
    props: {
      "plainText": $cmp.additionalDetails
    },
    key: 7
  }) : null, $cmp.hasCards ? api_element("div", stc2, api_iterator($cmp.cards, function (plan) {
    return api_custom_element("listing-pricing-card", _listingPricingCard, {
      attrs: stc3,
      props: {
        "planName": plan.planName,
        "formattedPrice": plan.formattedPrice,
        "unitFrequencyLabel": plan.unitFrequencyLabel,
        "showLowestStartingPriceBadge": plan.showLowestStartingPriceBadge,
        "lowestStartingPriceLabel": $cmp.staticLabels.lowestStartingPrice,
        "trialPeriodLabel": plan.trialPeriodLabel,
        "centered": plan.centered
      },
      key: api_key(9, plan.index)
    });
  })) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-62rkjuivrub";
tmpl.legacyStylesheetToken = "undefined-_pricingV2";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
